import { render, staticRenderFns } from "./InterestRecordForm.vue?vue&type=template&id=84be8e80&scoped=true&"
import script from "./InterestRecordForm.vue?vue&type=script&lang=js&"
export * from "./InterestRecordForm.vue?vue&type=script&lang=js&"
import style0 from "./InterestRecordForm.vue?vue&type=style&index=0&id=84be8e80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84be8e80",
  null
  
)

export default component.exports